import { RequestStatus } from 'features/request/requestSlice';
import { useRequest } from 'features/request/useRequest';
import { exportActKC2AsExcelGql } from 'pages/Project/UerProject/WorkOrder/workOrderQueries';
import { ExportCSVReport } from 'utils/createCSVReportFile';
import { downloadURI } from 'utils/downloadDataURI';

import { useCallback, useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';

export const useActKC2Download = (actKC2Id: number) => {
    const dispatch = useDispatch();

    const [isSubmittedDownload, setIsSubmittedDownload] = useState<boolean>(false);

    const [
        actKC2AsExcelData,
        actKC2AsExcelStatus,
        actKC2AsExcelError,
        actKC2AsExcel,
        setActKC2AsExcelData,
        actKC2AsExcelAbort,
    ] = useRequest({
        requestId: `actKC2AsExcel_${actKC2Id}`,
        query: exportActKC2AsExcelGql,
        withEffect: false,
    });

    const asyncDownloadURI = async (dataUrl: string, name: string) => {
        await downloadURI(dataUrl, name);
    };

    useEffect(() => {
        if (
            isSubmittedDownload &&
            actKC2AsExcelStatus === RequestStatus.SUCCESS &&
            actKC2AsExcelData?.uerExportActKC2AsExcel?.result
        ) {
            const { dataUrl, name } = actKC2AsExcelData.uerExportActKC2AsExcel.data!;

            asyncDownloadURI(dataUrl, name);
            dispatch(setActKC2AsExcelData(undefined));
            setIsSubmittedDownload(false);
        }
    }, [dispatch, setActKC2AsExcelData, actKC2AsExcelData, actKC2AsExcelStatus, isSubmittedDownload]);

    const handleDownloadActKC2 = useCallback(() => {
        dispatch(actKC2AsExcel({ actKC2Id }));
        setIsSubmittedDownload(true);
    }, [dispatch, actKC2AsExcel, actKC2Id]);

    const handleCloseModalErrorDownload = useCallback(() => {
        setIsSubmittedDownload(false);
    }, []);

    const handleCreateReportDownload = () => {
        ExportCSVReport(actKC2AsExcelData?.uerExportActKC2AsExcel?.validation);
    };

    const handleActKC2AsExcelAbort = useCallback(() => {
        dispatch(actKC2AsExcelAbort());
        setIsSubmittedDownload(false);
    }, [actKC2AsExcelAbort, dispatch]);

    return {
        isSubmittedDownload,
        actKC2AsExcelData,
        actKC2AsExcelStatus,
        actKC2AsExcelError,
        handleActKC2AsExcelAbort,
        handleDownloadActKC2,
        handleCloseModalErrorDownload,
        handleCreateReportDownload,
    };
};
